// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1kGxy","inputDescription":"styles_inputDescription__3oFm4"};